import produce from "immer";
import { ColumnFormatDict } from "../../../requests/templates/types";
import { columnFormatPLACEHOLDER } from "../../../requests/templates/types/placeholderData";
import { muiIconOptions } from "../../atoms/inputs/IconSelector/muiIconNames";

export const APP_TABLE_NAME = "Tables";
export const APP_TABLE_IGNORE_COLUMNS = [
  "Type",
  "ColumnSchema",
  "DatasourceID",
];

export const TEMPLATE_TABLE_NAME = "Templates";
export const TEMPLATE_TABLE_IGNORE_COLUMNS = [
  "Table",
  "TemplateJSON",
  "DataTemplateJSON",
  "PresentationTemplateJSON",
  "RelativePath",
  "TableSchema",
  "TableName",
  "Description",
  "LatestVersion",
  "IsDeleted",
  "DisplayAs",
  "TableID",
  "ColumnSchema",
  "Order",
  "Type",
  "ModuleID",
  "NameCs",
  "NameEn",
  "DisplayAsEn",
  "DisplayAsCs",
  "TranslationsJSON",
  "DeviceId",
];

export const MODULES_TABLE_NAME = "Modules";
export const MODULES_TABLE_IGNORE_COLUMNS = [
  "Desc",
  "NameCs",
  "NameEn",
  "TranslationsJSON",
];

export const USERS_TABLE_NAME = "Users";
export const USERS_TABLE_IGNORE_COLUMNS = [
  "PasswordHash",
  "LastResetPassword",
  "Salt",
  "ResetPasswordToken",
];

export const ROLES_TABLE_NAME = "Roles";
export const ROLES_TABLE_IGNORE_COLUMNS = [];

export const FUNCTIONS_TABLE_NAME = "Functions";
// Tady se přidají do requesty i paramsJSON pro modal úpravy funkce, je potřeba je odstranit z tabulky
export const FUNCTIONS_TABLE_IGNORE_COLUMNS = [
  "SkipRecordsOnError",
  "ParamsJSON",
  "WorkflowCommentType",
  "DatasourceID",
  "NameCs",
  "NameEn",
  "TranslationsJSON",
];

export const DATA_SOURCES_TABLE_NAME = "Datasources";
export const DATA_SOURCES_TABLE_IGNORE_COLUMNS = [
  "DbLogin",
  "DbPassword",
  "Type",
  "MaxConcurrentConnections",
  "LoginType",
  "BasicLoginPurpose",
  "DomainLoginPurpose",
  "GoogleLoginPurpose",
];

// Základní config zajišťující, aby FlowioTableCellInput vykresloval správná data

export const ADMIN_TEMPLATE_ITEM_IDS = {
  icon: 1001,
  searchSelect: 1002,
  displayAs: 101,
  module: 102,
};

export const ADMIN_COLUMN_FORMAT_DICT: ColumnFormatDict = {
  [ADMIN_TEMPLATE_ITEM_IDS.icon]: produce(columnFormatPLACEHOLDER, (draft) => {
    draft.value.general.iconOptions = muiIconOptions;
    draft.value.general.asIcon = true;
  }),

  [ADMIN_TEMPLATE_ITEM_IDS.searchSelect]: produce(
    columnFormatPLACEHOLDER,
    (draft) => {
      draft.value.typeSpecific.select = { displayAsSearchSelect: true };
    }
  ),

  [ADMIN_TEMPLATE_ITEM_IDS.displayAs]: produce(
    columnFormatPLACEHOLDER,
    (draft) => {
      draft.value.general.required = false;
    }
  ),

  [ADMIN_TEMPLATE_ITEM_IDS.module]: produce(
    columnFormatPLACEHOLDER,
    (draft) => {
      draft.value.general.required = false;
    }
  ),
};
